import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ASSETS } from "@/lib/siteData";
import { RevealLines, FadeUp } from "./Shared";

const Panel = ({ src, label, idx }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <div ref={ref} className="relative overflow-hidden aspect-square border border-[var(--line)]">
      <motion.img
        style={{ y, scale: 1.18 }}
        src={src}
        alt={label}
        data-testid={`ethos-img-${idx}`}
        className="w-full h-full object-cover"
      />
      <div className="absolute bottom-0 left-0 right-0 p-5 flex justify-between font-mono-plex text-[10px] uppercase tracking-[0.22em] text-[var(--off)]/80 bg-gradient-to-t from-black/60 to-transparent">
        <span>0{idx}</span>
        <span>{label}</span>
      </div>
    </div>
  );
};

export const Ethos = () => (
  <section data-testid="ethos-section" className="px-6 md:px-12 py-24 md:py-40 bg-[#060606]">
    <div className="mx-auto max-w-[1500px]">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <FadeUp className="flex items-baseline gap-4 mb-10 border-b border-[var(--line)] pb-6">
            <span className="font-mono-plex text-xs text-[var(--muted)]">—</span>
            <span className="font-mono-plex text-xs uppercase tracking-[0.28em] text-[var(--muted)]">The Ethos</span>
          </FadeUp>
          <RevealLines
            tag="h2"
            className="font-serif-display font-light text-4xl md:text-6xl tracking-tight leading-[0.92] mb-8"
            lines={["Two principles", "guide the practice."]}
          />
          <FadeUp delay={0.1}>
            <p className="text-base md:text-lg text-[var(--off)]/70 leading-relaxed max-w-md">
              Every brief is met with the same discipline — a consistent method, patiently applied, and a record built on outcomes earned for clients over twenty-six years.
            </p>
          </FadeUp>
        </div>
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-8">
          <Panel src={ASSETS.consistency} label="Consistency" idx={1} />
          <Panel src={ASSETS.success} label="Success" idx={2} />
        </div>
      </div>
    </div>
  </section>
);
